import { Icon } from "@hireart/component-library";
import trendUpIcon from "hireart-icons/trend-up-1.svg";
import chevronRightIcon from "hireart-icons/chevron-right.svg";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import { Button } from "hireart-components";

export const PayDetails = ({
  payRate,
  canEditPayRate = false,
  onModalOpen,
  markup = "markup undetermined",
}) => {
  return (
    <Grid.Column>
      <p className="heading"> {payRate}</p>
      <p>pay rate</p>
      <hr />
      <div className="card-spacer">
        {canEditPayRate ? (
          <Button
            className="termination-link is-not-padded"
            size="md"
            basic
            fluid
            onClick={onModalOpen}
          >
            Edit
            <Icon src={chevronRightIcon} className="chevron-icon" />
          </Button>
        ) : (
          <span className="flex items-center gap-4">
            <Icon src={trendUpIcon} className="chevron-icon" />
            {markup}
          </span>
        )}
      </div>
    </Grid.Column>
  );
};

PayDetails.propTypes = {
  payRate: PropTypes.string.isRequired,
  canEditPayRate: PropTypes.bool,
  onModalOpen: PropTypes.func.isRequired,
  markup: PropTypes.string,
};
